import React from 'react';
import { DataGrid, GridColumns } from '@material-ui/data-grid';
import { AxiosResponse, CancelToken } from 'axios';
import { useFormData } from '@domain/hooks/use.form.data';
import { useAuth } from '@domain/auth/auth.hook';
import { CustomNoRowsOverlay } from '@components/datagrid/custom.no.rows.overlay';
import { TabTableContainer } from '@screens/players/player.details.tabs/tabs.tables.styles';
import { PlayerDataProps } from '@screens/players/types/player.data.props';
import MainPagination from '@components/main.pagination';
import { formatColWithDate } from '@components/datagrid/custom.datagrid.props';
import { GameType } from '@domain/game.selection/types/game.type';
import { useGame } from '@domain/game.selection/game.selection.hook';
import { MainDataGrid } from '@components/datagrid/main.data.grid';

const columns: GridColumns = [
  { field: 'missionId', headerName: 'Mission Id', width: 143 },
  { field: 'task', headerName: 'Task', width: 148 },
  { field: 'taskParam', headerName: 'Task Param', width: 152 },
  { field: 'count', headerName: 'Count', width: 120 },
  { field: 'required', headerName: 'Required', width: 133 },
  { field: 'timestamp', headerName: 'Timestamp', ...formatColWithDate, width: 149 },
  { field: 'coins', headerName: 'Coins', width: 113 },
  { field: 'stampName', headerName: 'Stamp Name', width: 159 },
  { field: 'seasonId', headerName: 'Season Id', width: 140 },
  { field: 'startDate', headerName: 'Start Date', ...formatColWithDate, width: 141 },
  { field: 'endDate', headerName: 'End Date', ...formatColWithDate },
  { field: 'theme', headerName: 'Theme', width: 123 },
  { field: 'minLevel', headerName: 'Level', width: 110 },
  { field: 'pot', headerName: 'Pot' },
];

interface PlayerSeason {
  tourneyId: number;
  season: Season;
}

interface Season {
  id: number;
  scheduleStartDate: Date;
  scheduleEndDate: Date;
  startDate: Date;
  endDate: Date;
  theme: string;
  minLevel: number;
  pot: number;
}
let index = 0;
function createData(playerSeason: PlayerSeason) {
  index += 1;
  return {
    id: index,
    seasonId: playerSeason.season.id,
    startDate: playerSeason.season.startDate,
    endDate: playerSeason.season.endDate,
    theme: playerSeason.season.theme,
    minLevel: playerSeason.season.minLevel,
    pot: playerSeason.season.pot,
    ...playerSeason,
  };
}

const PlayerSeasons = ({ player }: PlayerDataProps) => {
  const { authorizedServices } = useAuth();
  const { pid } = player;

  async function runSearch(requestPid: number, cancelToken: CancelToken | undefined) {
    return authorizedServices
      .get<PlayerSeason[]>(`/admin/seasons/player/${requestPid}`, { cancelToken })
      .catch((error) => {
        if (error && error.response && error.response.status === 404) return { ...error.response, data: [] } as AxiosResponse<PlayerSeason[]>;
        throw error;
      });
  }

  const formData = useFormData(pid, runSearch, { autoRequest: true });
  const { response } = formData;
  const result = response?.data;
  const headers = response?.headers;
  const pageCount = parseInt(headers?.totalpages || '1', 10);

  const rows = result?.map(createData) || [];

  return (
    <TabTableContainer>
      <MainDataGrid columns={columns} rows={rows} loading={formData.loading} error={formData.error} pageCount={pageCount} />
    </TabTableContainer>
  );
};

export default PlayerSeasons;
